export const INITIAL_STATE_CETIP_ISIN = {
    inputValue: "",
    selectedValue: null,
    results: [],
    loading: false,
}

export const CETIP_AUTOCOMPLETE_ACTIONS = {
    SET_INPUT_VALUE: "SET_INPUT_VALUE",
    SET_SELECTED_VALUE: "SET_SELECTED_VALUE",
    SEARCH_START: "SEARCH_START",
    SEARCH_SUCCESS: "SEARCH_SUCCESS",
    SEARCH_ERROR: "SEARCH_ERROR",
    SEARCH_CLEAR: "SEARCH_CLEAR",
    RESET_STATE: "RESET_STATE",
}

export const AUTOCOMPLETE_CONFIG = {
    MIN_SEARCH_LENGTH: 4,
    DEBOUNCE_DELAY: 300,
    MAX_RESULTS: 50,
}

export const ERROR_MESSAGES = {
    SEARCH_FAILED: "Erro na busca",
    NETWORK_ERROR: "Erro de conexão",
    INVALID_INPUT: "Entrada inválida",
}
